import { render, staticRenderFns } from "./DetailInfo.vue?vue&type=template&id=23b39564&scoped=true"
import script from "./DetailInfo.vue?vue&type=script&lang=js"
export * from "./DetailInfo.vue?vue&type=script&lang=js"
import style0 from "./DetailInfo.vue?vue&type=style&index=0&id=23b39564&prod&scoped=true&lang=css"
import style1 from "./DetailInfo.vue?vue&type=style&index=1&id=23b39564&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b39564",
  null
  
)

export default component.exports